import axios from 'axios'

// Determine the API base URL based on environment
const getApiBaseUrl = () => {
  if (import.meta.env.DEV) {
    // Development: use local API
    return '/api'
  } else {
    // Production: use Cloudflare Workers API
    return 'https://mifo-inventory-manager-api.relgrowth.workers.dev/api'
  }
}

// Create axios instance with base URL
const api = axios.create({
  baseURL: getApiBaseUrl()
})

// Request interceptor to add auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token')
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Response interceptor to handle auth errors
api.interceptors.response.use(
  (response) => {
    return response
  },
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid, redirect to login
      localStorage.removeItem('auth_token')
      window.location.href = '/herzbeben'
    }
    return Promise.reject(error)
  }
)

export default api 